import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, user, toggle, pdfManager,
    FetchData, Helpers,
    //------------- Forms
    Forms,
    globalStates

}) => {

    const { convertToFloat, drawPaymentTicket } = Helpers

    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });

    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowForm = (openingMode) => {
        const { setShowForm, setFormOpeningMode } = globalStates
        setFormOpeningMode(openingMode)
        setShowForm(true)
    }

    const handleClickHideForm = () => {

        const { setShowForm, setStepApplilication } = globalStates

        const { fetchAllVehicleSales: { executeFetchAllVehicleSales } } = FetchData

        const { FormRequestGlobal: { onResetForm } } = Forms

        onResetForm()
        executeFetchAllVehicleSales()

        setStepApplilication(0)
        setShowForm(false)
    }

    const handleClickReturnStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication - 1)
    }

    const handleClickNextStep = () => {
        const { stepApplilication, setStepApplilication } = globalStates
        setStepApplilication(stepApplilication + 1)
    }



    const handleClickCleanUpFiles = (event) => {
        const { FormRequestGlobal: { setFormState } } = Forms

        setFormState(prevState => ({
            ...prevState,
            fileRejections: [],
            acceptedFiles: []
        }))

    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;


        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (clean_deposito_monto / tipo_cambio)
            }))
        }
    }


    const onSubmitFormApplies = async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers

        //HOOKS
        const { FormRequestGlobal: { formState, setFormState } } = Forms

        const { formOpeningMode } = globalStates

        // const { fetchAllLeaseApplications, fetchAllFiles } = FetchData
        // const { executeFetchAllLeaseApplications } = fetchAllLeaseApplications
        // const { executeFetchAllFiles } = fetchAllFiles

        //Validaciones generales
        if (formState.idcliente == 0) {
            const messageCustom = {
                message: 'Debe seleccionar un cliente',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (formState.idvehiculo == 0) {
            const messageCustom = {
                message: 'Debe seleccionar un vehiculo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        let _data = {
            idvehiculo: formState.idvehiculo,
            idcliente: formState.idcliente,
            monto_venta: formState.clean_monto_venta,
            fecha_venta: formState.fecha_venta,
            aprobacion_check: formState.aprobacion_check,
            aprobacion_usuario: user.username,
            aprobacion_fecha: formState.aprobacion_fecha,
        }

        if (formState.idventa > 0) {


            if (formOpeningMode === 'EDITABLE') {

                _data['usuario_modifico'] = user.username;
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put(`/vehicle/mgmt-sales/${formState.idventa}`, _data)
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            handleClickNextStep()
                        }

                    }).catch(error => { console.log('API ERROR: ', error) })
            } else {
                handleClickNextStep()
            }

            handleClickNextStep()


        } else {

            _data['usuario_creo'] = user.username;
            _data['fecha_creo'] = getCurrentDate();

            // console.log(_data)

            await marvarApi.post(`/vehicle/mgmt-sales/create-sale`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {

                        setFormState((prevState) => ({
                            ...prevState,
                            idventa: data.rows.insertId,
                        }))
                        handleClickNextStep()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        }

    }

    const onSendLogs = async (e) => {


        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { fetchInfoObservations: { executeFetchAllObservations } } = FetchData


        const { getCurrentDate } = Helpers

        await marvarApi.post(`/vehicle/mgmt-sales/log-vehicle/${formState.idventa}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState((prevState) => ({
                        ...prevState,
                        aprobacion_observaciones: ''
                    }))
                    executeFetchAllObservations()
                }
            })

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()

        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { getCurrentDate } = Helpers


        const { fetchAllFiles: { executeFetchAllFiles } } = FetchData



        if (formState.acceptedFiles.length <= 0) {
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = new FormData();

        _data.append('idventa', formState.idventa);
        _data.append('department', 'GESTOR');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if (formState.idventa > 0) {

            await marvarApi.post(`/vehicle/mgmt-sales/create-document`, _data)
                .then(({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            acceptedFiles: [],
                            fileRejections: []
                        }))
                        executeFetchAllFiles()
                    }
                    alertMessage(data)
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleClickDeleteDocument = (iddocumento) => {

        const { fetchAllFiles: { executeFetchAllFiles } } = FetchData

        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/mgmt-sales/delete-document/${iddocumento}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllFiles()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }


    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit, FormPreInvventory } = Forms
        const { onResetForm } = FormDeposit
        const onResetFormInvventory = FormPreInvventory.onResetForm
        onResetForm()
        onResetFormInvventory()
        closeModal()
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData

        const { getCurrentDate } = Helpers


        if (formState.movimiento_tipo === 'EFECTIVO') {

            const _data = {
                idventa: formStateGlobal.idventa,
                deposito_usuario: user.username,
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: formState.clean_deposito_monto,
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: formState.deposito_tipo_cambio,
                deposito_quetzal: formState.clean_deposito_quetzales,
                deposito_dolares: formState.clean_deposito_dolares,
                idcaja: formState.idcaja,
                deposito_observaciones: formState.deposito_observaciones,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate()
            }

            await marvarApi.post(`/vehicle/mgmt-sales/create-deposit-cash`, _data)
                .then(async({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchAllDeposits()
                        closeModal()
                        await handleClickDownloadTicket(data.insertId)

                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }

        if (formState.movimiento_tipo === 'DEPOSITO') {

            if (formState.acceptedFiles.length <= 0) {

                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }

                alertMessage(messageCustom)

                return
            }

            const _data = new FormData();

            _data.append('idventa', formStateGlobal.idventa)
            _data.append('idbanco', formState.idbanco)
            _data.append('movimiento_tipo', formState.movimiento_tipo)
            _data.append('deposito_fecha', formState.deposito_fecha)
            _data.append('deposito_usuario', user.username)
            _data.append('deposito_monto', formState.clean_deposito_monto)
            _data.append('deposito_moneda', formState.deposito_moneda)
            _data.append('deposito_tipo_cambio', formState.deposito_tipo_cambio)
            _data.append('deposito_quetzal', formState.clean_deposito_quetzales)
            _data.append('deposito_dolares', formState.clean_deposito_dolares)
            _data.append('boleta_numero', formState.boleta_numero)
            _data.append('usuario_creo', user.username)
            _data.append('fecha_creo', getCurrentDate())

            formState.acceptedFiles.forEach((file, index) => {
                _data.append(`images`, file);
            });

            await marvarApi.post(`/vehicle/mgmt-sales/create-deposit-bank`, _data)
                .then(async({ data }) => {
                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllDeposits()
                        onResetForm()
                        closeModal()
                        await handleClickDownloadTicket(data.insertId)

                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormDeposit
        const { deposito_tipo_cambio } = formState

        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value * tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value),
                deposito_dolares: numberFormatter.format(clean_value / tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value / tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        // const monto = deposito_monto !== '' ? deposito_monto : 0;
        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto / tipo_cambio)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const handleClickFetchInfoDeposit = async (iddeposit) => {

        const { FormDeposit: { onResetForm } } = Forms


        const { fetchInfoDeposit: { setParamsToSearch, executeFetchInfoDeposit } } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ iddeposit: iddeposit })
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleClickDownloadImage = async (customFileName, openUrl) => {

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();

            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);

            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();

            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);

            toast.success('Se ha descargado la imagen');

        } catch (error) {
            console.error('Error al descargar la imagen', error);
        }

    }

    const handleClickDeleteDeposit = (iddeposit) => {

        const { fetchAllDeposits: { executeFetchAllDeposits } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/mgmt-sales/delete-deposit/${iddeposit}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllDeposits()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const onSubmitFormPreInventory = async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers

        //HOOKS
        const { FormPreInvventory: { formState }, FormRequestGlobal } = Forms
        const formStateGlobal = FormRequestGlobal.formState

        const { modalOpeningMode } = globalStates

        const { fetchAllPreInventory: { executeFetchAllPreInventory } } = FetchData


        let _data = {
            idventa: formStateGlobal.idventa,
            valor: formState.clean_valor,
            marca: formState.marca,
            modelo: formState.modelo,
            linea: formState.linea,
            color: formState.color,
            matricula: formState.matricula,
            chasis: formState.chasis,
        }


        if (formState.idvehicledeposit > 0) {

            if (modalOpeningMode === 'EDITABLE') {

                _data['usuario_modifico'] = user.username;
                _data['fecha_modifico'] = getCurrentDate();

                await marvarApi.put(`/vehicle/mgmt-sales/pre-inventory/${formState.idvehicledeposit}`, _data)
                    .then(({ data }) => {

                        alertMessage(data)

                        if (data.title === 'OK') {
                            executeFetchAllPreInventory()
                            handleClickCloseModal()
                        }

                    }).catch(error => { console.log('API ERROR: ', error) })
            } else {
                executeFetchAllPreInventory()
                handleClickCloseModal()
            }

        } else {

            _data['usuario_creo'] = user.username;
            _data['fecha_creo'] = getCurrentDate();

            await marvarApi.post(`/vehicle/mgmt-sales/pre-inventory`, _data)
                .then(({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        executeFetchAllPreInventory()
                        handleClickCloseModal()
                    }

                }).catch(error => { console.log('API ERROR: ', error) })
        }

    }


    const handleClickFetchInfoPreInventory = async (idvehicledeposit, modeOpening) => {

        const { FormPreInvventory: { onResetForm } } = Forms

        const { fetchInfoPreInventory: { setParamsToSearch, executeFetchPreInventory } } = FetchData

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idvehicledeposit: idvehicledeposit })
        executeFetchPreInventory()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de Pre Inventario', 'preinventory-section', {}, modeOpening)

    }

    const handleClickDeletePreInventory = (idvehicledeposit) => {

        const { fetchAllPreInventory: { executeFetchAllPreInventory } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/mgmt-sales/delete-pre-inventory/${idvehicledeposit}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllPreInventory()
                        } else {

                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickFetchInfoSales = async (idventa, modeOpening) => {

        const { FormRequestGlobal: { onResetForm, setFormState } } = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()

        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setFormState(prevState => ({
            ...prevState,
            idventa: idventa,
        }))

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowForm(modeOpening)

    }

    const handleClickDeleteVehiclSale = (idventa) => {

        const { fetchAllVehicleSales: { executeFetchAllVehicleSales } } = FetchData
        Swal.fire({
            title: '¿Desea eliminar este registro?',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/vehicle/mgmt-sales/${idventa}`)
                    .then(({ data }) => {
                        alertMessage(data)
                        if (data.title === 'OK') {
                            executeFetchAllVehicleSales()
                        }
                    }).catch(error => {
                        console.log('API ERROR: ', error)
                    })
            }
        })
    }

    const handleClickApproval = async () => {
        //HOOKS
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal
        const { getCurrentDate } = Helpers


        if (formState.aprobacion_check === 'Devuelto a Gestor') {
            await marvarApi.put(`/vehicle/admin-sales/aprobacion-check-sale/${formState.idventa}`, { aprobacion_check: 'Pendiente Aprobacion', aprobacion_usuario: user.username, aprobacion_fecha: getCurrentDate() })
                .then(({ data }) => {
                    alertMessage(data)
                    handleClickHideForm()
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
        } else {
            handleClickHideForm()
        }
    }

    const handleClickDownloadTicket = async (idmovimiento) => {
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-sales/get-deposit-by-ID/${idmovimiento}`)
            if (response.data.title === 'OK') {
                const _dataForPDF = {
                    idmovimiento: response.data.data.iddeposit,
                    aprobacion_check: response.data.data.aprobacion_check,
                    datos_cliente: response.data.data.nombre_cliente,
                    movimiento_quetzales: numberFormatter.format(response.data.data.deposito_quetzal),
                    deposito_fecha: response.data.data.deposito_fecha,
                    contrato_codigo: `VV${response.data.data.idventa}`,
                    movimiento_tipo: response.data.data.movimiento_tipo,
                    movimiento_monto: numberFormatter.format(response.data.data.deposito_monto),
                    deposito_moneda: response.data.data.deposito_moneda,
                    deposito_tipo_cambio: response.data.data.deposito_tipo_cambio,
                    movimiento_dolares: numberFormatter.format(response.data.data.deposito_dolares),
                    descripcion_caja: response.data.data.nombre_caja,
                    descripcion_banco: response.data.data.nombre_banco,
                    boleta_numero: response.data.data.boleta_numero,
                    aprobacion_referencia_ach: response.data.data.aprobacion_referencia_ach,
                    deposito_observaciones: response.data.data.deposito_observaciones,
                    aprobacion_observaciones: response.data.data.aprobacion_observaciones
                }

                drawPaymentTicket(pdfManager, _dataForPDF)
            }
        } catch (e) {
            console.log('API ERROR: ', e)
        }
    }



    return Object.freeze({
        handleClickShowForm,
        handleClickHideForm,
        onSubmitFormApplies,
        onSendLogs,
        handleClickCleanUpFiles,
        handleClickReturnStep,
        handleClickNextStep,
        onSubmitFormFiles,
        handleClickDeleteDocument,
        handleClickShowModal,
        handleClickCloseModal,
        onSubmitFormDeposits,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        handleClickFetchInfoSales,
        handleClickFetchInfoDeposit,
        handleClickDownloadImage,
        handleClickDeleteDeposit,
        onSubmitFormPreInventory,
        handleClickFetchInfoPreInventory,
        handleClickDeletePreInventory,
        handleClickDeleteVehiclSale,
        handleClickApproval,
        handleClickDownloadTicket,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}